import {
  isFilterItemServable,
  isSortFieldServable,
  RequestFilterableField,
  RequestSortableField,
} from '@omnea-app/requests/requestsFrontendClient'

// Isomorphic (no Kysely/DB imports): the frontend reads it to know which My Tasks columns the server can
// filter and sort, and the backend reads it to reject everything else.

// A rename on the Requests side fails the build here rather than leaving a My Tasks column unserved at runtime.
type RequestField = RequestFilterableField | RequestSortableField

// My Tasks column field → the Requests list field that serves it. Each task is one step of one request, so
// these columns filter, search and sort by the request exactly as the Requests table does. Value and annual
// value are left to the browser: the Requests list compares amounts converted to the org's currency (and
// annualised), while these columns show the request's own amount.
export const MY_TASKS_REQUEST_FIELDS = {
  name: 'name',
  publicId: 'publicId',
  supplierName: 'supplier',
  type: 'workflowTitle',
  createdByName: 'createdBy',
  owner: 'projectOwner',
  department: 'department',
  buyerLegalEntity: 'buyerLegalEntity',
  priority: 'priority',
  tags: 'tags',
  autoGeneratedTags: 'autoGeneratedTags',
  requestStatus: 'operationalStatus',
} as const satisfies Record<string, RequestField>

type MyTasksRequestField = keyof typeof MY_TASKS_REQUEST_FIELDS

// Ordered by the task itself rather than its request.
export const MY_TASKS_STEP_SORT_FIELD = 'createdAt'

// Object.hasOwn, not `in`: the field comes from the request body, and 'constructor'/'__proto__' would
// otherwise resolve to an inherited member.
export const toRequestField = (field: string): RequestField | undefined =>
  Object.hasOwn(MY_TASKS_REQUEST_FIELDS, field) ? MY_TASKS_REQUEST_FIELDS[field as MyTasksRequestField] : undefined

export const isMyTasksFilterItemServable = (item: { field: string; operator: string; value?: unknown }): boolean => {
  const requestField = toRequestField(item.field)
  return requestField !== undefined && isFilterItemServable({ ...item, field: requestField })
}

export const isMyTasksSortFieldServable = (field: string): boolean => {
  if (field === MY_TASKS_STEP_SORT_FIELD) return true
  const requestField = toRequestField(field)
  return requestField !== undefined && isSortFieldServable(requestField)
}
